export default "__VITE_ASSET__uhRIDELx__"